<template lang="pug">
.yz-date-picker-wrapper(:style="wrapperStyle")
  v-date-picker(
    v-model="internalValue"
    :picker-date.sync="internalPickerDate"
    v-bind="$attrs"
    v-on="$listeners"
    @change="handleChange"
    @input="handleInput"
  )
</template>

<script>
export default {
  name: 'YzDatePicker',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    pickerDate: {
      type: String,
      default: null
    },
    maxWidth: {
      type: [String, Number],
      default: 350
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    internalPickerDate: {
      get() {
        return this.pickerDate
      },
      set(newValue) {
        this.$emit('update:pickerDate', newValue)
      }
    },
    wrapperStyle() {
      const maxWidth = typeof this.maxWidth === 'number' ? `${this.maxWidth}px` : this.maxWidth
      return {
        maxWidth,
        // margin: '0 auto'
      }
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    },
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-date-picker-title__year {
    display: none;
  }

  .v-date-picker-title__date {
    display: none;
  }

  .v-picker__title {
    padding: 0;
  }

  .v-picker__body {
    width: 100% !important;
  }

  .v-date-picker-header {
    height: 50px;
  }

  .v-date-picker-header > button {
    position: absolute !important;
    width: 24px;
    border-radius: 5px;
    color: black !important;
  }

  .v-date-picker-header > button[aria-label='Previous month'],
  .v-date-picker-header > button[aria-label='Previous year'] {
    right: 53px;
    font-size: 20px;
  }

  .v-date-picker-header > button[aria-label='Next month'],
  .v-date-picker-header > button[aria-label='Next year'] {
    right: 24px;
  }

  .v-date-picker-header > div {
    position: absolute !important;
    font-size: 14px;
    font-weight: 700;
  }

  .v-date-picker-header .v-date-picker-header__value button::after {
    font-family: 'Material Design Icons';
    content: '\F0140';
    margin-left: 12px;
  }

  .v-date-picker-table th {
    font-size: 15px;
    color: var(--v-neutral400) !important;
    height: 44px;
    border-bottom: 1px solid rgb(244, 244, 244);
    border-top: 1px solid rgb(244, 244, 244);
  }

  .v-date-picker-table--date {
    height: 330px;
  }

  .v-date-picker-table .v-btn {
    height: 44px;
    width: 44px;
    font-size: 15px !important;
    font-weight: 600;
    border-radius: 8px !important;
    color: black !important;
  }

  .v-date-picker-table__current {
    border: 2px solid black;
    color: black !important;
    background-color: rgba(51, 51, 51, 0.08);
  }

  .v-date-picker-table .v-btn.v-btn--disabled {
    color: var(--v-neutral400) !important;
  }

  .v-date-picker-table .v-btn.v-btn--active {
    background-color: black !important;
    color: white !important;
    border-color: black !important;
  }

  .v-date-picker-table--date .v-date-picker-table__events {
    bottom: 12px;
  }

  .v-date-picker-table__events > div {
    width: 5px;
    height: 5px;
  }

  .v-date-picker-table--month td .v-btn {
    margin: 0 auto;
    max-width: 140px;
    min-width: 40px;
    width: 100%;
    font-size: 15px !important;
    font-weight: 600 !important;
  }

  .v-date-picker-years {
    font-size: 15px;
    font-weight: 600;
    height: 290px;
    list-style-type: none;
    overflow: auto;
    text-align: center;
  }
}
</style>
